module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_1@2x.04466fc9.png";